var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin_Docter_Page"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-1387 -201)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Main",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 48",
    x: -1107,
    y: -121,
    width: 1160,
    height: 945,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Booking"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 58",
    x: -130,
    y: -10,
    width: 160,
    height: 40,
    rx: 16,
    fill: "#007BFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Add"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 50",
    y: 6,
    width: 20,
    height: 8,
    fill: "#FFFDFD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 51",
    x: 6,
    width: 8,
    height: 20,
    fill: "#FFFDFD"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1160,
    height: 944,
    fill: "white",
    transform: "translate(-1107 -121)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.c03ef3c297083a0e1cd08517fa99d359.svg";
export { ForwardRef as ReactComponent };